import axios from 'axios'
import { getUserInfo } from 'modules/Auth/actions'
import authSelector from 'modules/Auth/selectors'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import request from 'utils/request'
import authRequested from '../../utils/authRequested'
export const setUserData = payload => {
  return {
    type: 'SET_USER_DATA',
    payload,
  }
}

export const changePassword = payload => async (dispatch, getState) => {
  const state = getState()
  const userId = authSelector.getUserId(state)
  try {
    let data = await request.patch(`/user/${userId}/password`, payload)
    return data
  } catch (error) {
    return error
  }
}

export const updateNotification = (userId, payload) => async () => {
  try {
    await request.put(`/user/${userId}/notification-preference`, payload)
    return true
  } catch (error) {
    return error
  }
}

export const getFile = async (url, file, fileURL) => {
  if (url && file) {
    try {
      let fileType = file.type
      let options = {
        headers: {
          'Content-Type': fileType,
        },
      }
      const { status } = await axios.put(url, file, options)
      if (status >= 200 && status < 300) {
        SuccessMessage('File Uploaded Successfully!')
        return fileURL
      }
      return false
    } catch (error) {
      ErrorMessage('Failed to upload!')
      return false
    }
  } else {
    ErrorMessage('Failed to upload!')
    return false
  }
}

export const uploadFile = (file, fileName) => async () => {
  try {
    if (file) {
      const data = await request.post(`/signedURL`, {
        files: [
          {
            fileName: fileName,
          },
        ],
      })

      if (data.status >= 200 && data.status < 300) {
        let url = getFile(
          data?.data?.data[0]?.signedURL,
          file,
          data?.data?.data[0]?.fileURL
        )
        return url
      }
    }
  } catch (error) {
    ErrorMessage('Failed to upload!')
    return false
  }
}

export const deleteFile = fileUrl => async () => {
  try {
    if (fileUrl) {
      const data = await request.delete(`/deleteFile`, {
        data: { fileUrl: fileUrl },
      })

      if (data.status >= 200 && data.status < 300) {
        return true
      }
    } else {
      return false
    }
  } catch (error) {
    return false
  }
}

export const SendOtp = payLoad => async (dispatch, getState) => {
  const state = getState()
  const userId = authSelector.getUserId(state)
  try {
    let response = await authRequested.post(`/users/${userId}/sendotp`, payLoad);
    if(response?.status === 201){
      response?.data?.message === 'Success' &&
      SuccessMessage('OTP Sent Successfully')
    return response
    }else{
      return response?.data;
    } 
  } catch (error) {
    return error
  }
}

export const checkOtp = payLoad => async (dispatch, getState) => {
  const state = getState()
  const userId = authSelector.getUserId(state)
  try {
    const data = await authRequested.patch(`/users/${userId}/phone`, payLoad);
    if(data.status === 200){
      SuccessMessage('OTP Verified Successfully')
      return data
    }else{
      // ErrorMessage(data?.data?.message)
      return data.data
    }
  } catch (error) {
    return error
  }
}

export const updateUserData = payload => async (dispatch, getState) => {
  const state = getState()
  const userId = authSelector.getUserId(state)
  try {
    let upd = await request.put(`/user/${userId}`, payload)
    if (upd?.status >= 200 && upd?.status <= 300) {
      SuccessMessage('Personal info saved successfully!')
      dispatch(getUserInfo())
    } else {
      ErrorMessage(upd?.upd?.data?.message)
    }
  } catch (error) {
    return error
  }
}
